import React from 'react';
import styled from 'styled-components/macro';
import { Formik, Field } from 'formik';
import {
  Modal,
  ModalActions,
  ModalContent,
  Button,
  Input,
  Select,
  ModalTitle,
  Checkbox,
} from '@deeptrue-frontend/ui';
import { useFormatMessage } from 'components/IntlProvider';
import ErrorMessages from 'components/Fields/ErrorMessages';

const StyleInputFile = styled(Input)`
  border: none;
  padding: 1rem 0;

  &:hover {
    box-shadow: none;
  }
  &:active,
  &:focus {
    padding: 1rem 0;
  }
`;

export interface FormValues {
  name?: string;
  context_name?: string;
  language: string;
  asset?: any;
  non_field_errors?: any;
  is_global: boolean;
}

interface Props {
  isVisible: boolean;
  onClose: () => void;
  uploadAsset: any;
  initialValues: FormValues;
}

const StyledButton = styled(Button)`
  width: 100%;
`;

const StyledModalAction = styled(ModalActions)`
  border: none;
`;

const AssetAddNew = ({
  isVisible,
  onClose,
  uploadAsset,
  initialValues,
}: Props) => {
  const t = useFormatMessage();

  return (
    <Modal
      isVisible={isVisible}
      onCloseClick={onClose}
      onBackdropClick={onClose}
    >
      <ModalTitle>{t('forms.assets.addAsset', 'Add Asset')}</ModalTitle>
      <Formik onSubmit={uploadAsset} initialValues={initialValues}>
        {({ handleSubmit, isSubmitting, errors, touched, setFieldValue }) => {
          const nonFieldErrors = errors.non_field_errors;

          return (
            <form onSubmit={handleSubmit}>
              <ModalContent>
                <Field
                  name="file"
                  as={StyleInputFile}
                  id="file"
                  type="file"
                  accept="video/*,image/*,video/mp4"
                  onChange={(event: any) => {
                    setFieldValue('asset', event.currentTarget.files[0]);
                  }}
                  hasError={touched.asset && errors.asset}
                  helperText={touched.asset && errors.asset}
                />

                <Field
                  name="name"
                  as={Input}
                  hasError={touched.name && errors.name}
                  helperText={touched.name && errors.name}
                  label={t('forms.assets.assetName', 'Asset Name')}
                  placeholder={t('forms.assets.assetName', 'Add Asset Name')}
                />
                <Field
                  name="context_name"
                  as={Input}
                  hasError={touched.context_name && errors.context_name}
                  helperText={touched.context_name && errors.context_name}
                  placeholder={t(
                    'forms.assets.assetContext.placeholder',
                    'Add Context Name'
                  )}
                  label={t('forms.assets.assetContext', 'Context Name')}
                />
                <Field
                  name="language"
                  as={Select}
                  options={[
                    {
                      value: 'en',
                      label: 'English',
                    },
                    {
                      value: 'fr',
                      label: 'Français',
                    },
                    {
                      value: 'de',
                      label: 'Deutsch',
                    },
                  ]}
                  hasError={touched.language && errors.language}
                  helperText={touched.language && errors.language}
                  label={t('forms.assets.language', 'Language')}
                />
                <Field
                  name="is_global"
                  as={Checkbox}
                  hasError={touched.is_global && errors.is_global}
                  helperText={touched.is_global && errors.is_global}
                  label={t('forms.assets.isGlobal', 'Is global?')}
                />
              </ModalContent>
              {nonFieldErrors && <ErrorMessages errors={nonFieldErrors} />}
              <StyledModalAction>
                <StyledButton
                  variant="primary"
                  type="submit"
                  isLoading={isSubmitting}
                  disabled={isSubmitting}
                >
                  {t('forms.assets.upload', 'Upload')}
                </StyledButton>
              </StyledModalAction>
            </form>
          );
        }}
      </Formik>
    </Modal>
  );
};

export default AssetAddNew;
